/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Draf_S2Inputs */

const en_tut_draf_s2 = /** @type {(inputs: Tut_Draf_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The host opens the **Draf AI** tab and presses **Buat draf AI**. It can take about a minute and you may leave the tab.`)
};

const id_tut_draf_s2 = /** @type {(inputs: Tut_Draf_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Host membuka tab **Draf AI**, lalu menekan **Buat draf AI**. Prosesnya bisa memakan waktu sekitar satu menit dan boleh ditinggalkan.`)
};

/**
* | output |
* | --- |
* | "The host opens the **Draf AI** tab and presses **Buat draf AI**. It can take about a minute and you may leave the tab." |
*
* @param {Tut_Draf_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_draf_s2 = /** @type {((inputs?: Tut_Draf_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Draf_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_draf_s2(inputs)
	return en_tut_draf_s2(inputs)
});